import React from "react";
import { MainContent } from "../../utilities/mainContent";
import TableData from "../../utilities/table";
import {
  Grid,
  IconButton,
  MenuItem,
  ListItemText,
  ListItemIcon,
  Typography,
} from "@mui/material";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import DeleteIcon from "@mui/icons-material/Delete";
import { MenuButtons } from "../../utilities/menuButton";
import EditIcon from "@mui/icons-material/Edit";
import { DialogBox } from "../../utilities/dialog";
import { Add } from "../users/add";
import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query";
import DepartmentServices from "../../../service/department";
import { DeleteContent } from "../../../hooks/utils";
import { usePerms } from "../../../hooks/usePerms";

const items = [
  {
    label: "Edit Sub Department",
    icon: <EditIcon fontSize="small" />,
  },
  {
    label: "Delete Sub Department",
    icon: <DeleteIcon fontSize="small" />,
  },
];

const itemAdmin = [
  {
    label: "Edit Sub Department",
    icon: <EditIcon fontSize="small" />,
  },
];

const csvCol = [
  {
    key: "name",
    label: "Title",
  },
  {
    key: "department",
    label: "Department",
  },
  {
    key: "createdAt",
    label: "Created At",
  },
  {
    key: "updatedAt",
    label: "Update At",
  },
];
export const SubDepartmentComponent = () => {
  const [anchorEl, setAnchorEl] = React.useState(null);
  const [isDialog, setIsDialog] = React.useState(false);
  const [setMobileOpens, setMobileOpenss] = React.useState(false);
  const [subDepartment, setSubDepartment] = React.useState(null);
  const [filtered, setFiltered] = React.useState(null);
  const [isDelete, setIsDelete] = React.useState(false);
  const queryClient = useQueryClient();
  // const entryRole = ['superAdmin'];
  const entryRole2 = ["admin"];
  // const { role } = usePerms('', entryRole);
  const { role: admin } = usePerms("", entryRole2);

  const { data, isLoading } = useQuery({
    queryKey: ["sub_department_list"],
    queryFn: () => DepartmentServices.allSubDepartments(),
  });

  const roleCheck = admin ? itemAdmin : items;

  const columns = [
    {
      field: "name",
      headerName: "Title",
      width: 400,
    },
    {
      field: "departName",
      headerName: "Department",
      width: 180,
    },
    {
      field: "createdAt",
      headerName: "Created At",
      width: 220,
    },
    {
      field: "updatedAt",
      headerName: "Update At",
      width: 200,
    },

    {
      field: "",
      headerName: "",
      width: 40,
      renderCell: (params) => {
        return (
          <Grid container justifyContent="flex-end">
            <IconButton
              aria-controls={open ? "fade-menu" : undefined}
              aria-haspopup="true"
              aria-expanded={open ? "true" : undefined}
              onClick={handleClick}
              // disabled={role ? false : true}
            >
              <MoreVertIcon />
            </IconButton>
            <MenuButtons
              anchorEl={anchorEl}
              open={open}
              handleClose={handleClose}
              items={roleCheck.map((item, index) => (
                <MenuItem
                  key={index}
                  onClick={() => handleMenuItem(item, params)}
                >
                  <ListItemIcon>{item.icon}</ListItemIcon>
                  <ListItemText>
                    <Typography variant="subtitle2">{item.label}</Typography>
                  </ListItemText>
                </MenuItem>
              ))}
            />
          </Grid>
        );
      },
    },
  ];
  const open = Boolean(anchorEl);
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };
  const toggleDrawer = () => {
    setMobileOpenss(!setMobileOpens);
  };
  const handleMenuItem = (item, params) => {
    if (item.label === "Departments") {
      toggleDrawer();
      setAnchorEl(null);
    } else if (item.label === "Edit Sub Department") {
      // navigate('/inspection/edit');
      setAnchorEl(null);
      setIsDialog(() => true);
    } else if (item.label === "Delete Sub Department") {
      setAnchorEl(null);
      setIsDelete(true);
    } else {
      return null;
    }
  };

  const { mutate } = useMutation({
    mutationFn: DepartmentServices.subDepartment,
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: ["sub_department_list"],
      });
      setIsDelete(false);
    },
  });

  return (
    <>
      <MainContent
        csvData={data}
        csvHeaders={csvCol}
        csvDataWithFilter={filtered || data}
        csvHeadersWithFilter={csvCol}
        valueFrom="add_subdepartment"
        fileNameWithFilter={"Sub Department list"}
        fileName={"Sub Department list"}
        onChangeSearch={(val) => {
          const searchVal = val?.target?.value || '';
          if (!searchVal) {
            setFiltered(() => data);
            return;
          }
          const value = (data || []).filter(
            (item) => item?.name?.toLowerCase().indexOf(searchVal.toLowerCase()) > -1
          );
          setFiltered(() => value);
        }}
        items={
          <TableData
            cols={columns}
            rows={filtered || data}
            maxWidthMob="84vw"
            height="400px"
            isLoading={isLoading}
            onRowClick={({ row }) => setSubDepartment(() => row)}
          />
        }
        isBtnName={true}
        btnName={"Add"}
        onBtnNameClick={() => {
          setSubDepartment(null);
          setIsDialog(true);
        }}
      />
      <DialogBox
        handleClose={() => setIsDialog(false)}
        open={isDialog}
        title={
          <Typography variant="subtitle1" component="span">
            Sub Department
          </Typography>
        }
        content={
          <Add
            label_name="SubDepartment"
            handleClose={() => setIsDialog(false)}
            subDepartment={subDepartment}
            mutationFn={
              subDepartment
                ? DepartmentServices.subDepartment
                : DepartmentServices.addSubDepartment
            }
          />
        }
      />
      <DialogBox
        handleClose={() => setIsDelete(false)}
        open={isDelete}
        maxWidth="500px"
        title={
          <Typography variant="subtitle1" component="span">
            Delete Department
          </Typography>
        }
        content={
          <DeleteContent
            title="Are you sure you want to delete this department?"
            onCancel={() => setIsDelete(false)}
            onSubmit={() => {
              const id = subDepartment.id;
              const method = "delete";
              mutate({ id, method });
            }}
          />
        }
      />
    </>
  );
};
